export default __webpack_public_path__ + "static/media/bf.bb616c9e.svg";